import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useCallback } from "react";
import "../style/controls/sameSectionAccordion.scss";
const SameSectionAccordion = (param)=>{
    let { title, children, onToggle, state, grouped } = param;
    // Uncontrolled
    const [open, setOpen] = useState(false);
    const handleClick = useCallback(()=>{
        onToggle == null ? void 0 : onToggle(!open);
        setOpen(!open);
    }, [
        open,
        setOpen
    ]);
    // Controlled
    const useOpen = state === undefined ? open : state;
    return /*#__PURE__*/ _jsxs("li", {
        className: `accordion-section same-section-accordion ${useOpen ? "same-section-accordion-open" : ""}`,
        style: {
            marginBottom: grouped ? 0 : undefined,
            borderBottom: grouped ? 0 : undefined
        },
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "accordion-section-title",
                onClick: handleClick,
                children: /*#__PURE__*/ _jsx("strong", {
                    children: title
                })
            }),
            useOpen && /*#__PURE__*/ _jsx("div", {
                children: children
            })
        ]
    });
};
export { SameSectionAccordion };
